var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ui-select ng-model=\"vm.game\" on-select=\"vm.updateCurrentGame($select.selected)\" ng-required=\"true\" remove-selected=\"false\" class=\"c-select c-select--uiselect c-header-dropdown\"><ui-select-match placeholder=\"{{ 'select'|translate }}\">{{$select.selected['name']}}<span ng-if=\"vm.game['status'] &amp;&amp; vm.game['status'] !== 'Active'\" ng-style=\"{'color': vm.game['status'] === 'Active' ? 'green' : 'red'}\"> ({{vm.game['status']}})</span></ui-select-match><ui-select-choices repeat=\"option in vm.games | filter: $select.search | limitTo: 30\"><div><span ng-bind-html=\"option['name'] | highlight: $select.search\"></span><span ng-if=\"option['status'] !== 'Active'\" ng-style=\"{'color': 'red'}\"> ({{option['status']}})</span></div></ui-select-choices></ui-select>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/header/header-games.jade
 ** module id = 575
 ** module chunks = 0
 **/